'use client'

import React, { useState } from 'react'
import { Card, Stack, Title, Text } from '@mantine/core'
import HealthDetailsAdaptiveModal from './HealthDetailsModal'
import { useMediaQuery } from '@mantine/hooks'
import { HealthCondition, HealthMedication, HealthAllergy, HealthProcedure } from '@/lib/store/api/chatApi'

export interface HealthCardData {
    type: 'conditions' | 'medications' | 'allergies' | 'procedures'
    title: string
    items: HealthCondition[] | HealthMedication[] | HealthAllergy[] | HealthProcedure[]
}

interface HealthCardProps {
    data: HealthCardData
}

const HealthCard: React.FC<HealthCardProps> = ({ data }) => {
    const [modalOpened, setModalOpened] = useState(false)
    const isMobile = useMediaQuery('(max-width: 768px)')
    const displayItems = data.items.slice(0, 3)
    const hasMore = data.items.length > 3
    
    return (
        <>
        <Card
            radius="md"
            style={{
                display: 'flex',
                backgroundColor: '#FAF7F5',
                border: 'none',
                width: '15.625rem',
                height: '11.3125rem',
                padding: '1.25rem',
            }}
        >
            <Stack gap="sm" h="100%">
                <Title order={4} fw={500} c="gray.9">
                    {data.title}
                </Title>
                
                <Stack gap="xs">
                    {displayItems.map((item, index) => (
                        <Text key={index} size="sm" c="gray.7" lineClamp={1}>
                            {item.name}
                        </Text>
                    ))}
                </Stack>
                
                {hasMore && (
                    <Text 
                        size="sm" 
                        c="blue.6" 
                        fw={500} 
                        mt="auto"
                        style={{ cursor: 'pointer' }}
                        onClick={() => setModalOpened(true)}
                    >
                        + {data.items.length - 3} more
                    </Text>
                )}
            </Stack>
        </Card>
        
        <HealthDetailsAdaptiveModal
            opened={modalOpened}
            onClose={() => setModalOpened(false)}
            title={data.title}
            items={data.items}
            type={data.type}
        />
        </>
    )
}

export default HealthCard
